import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'app-button',
  imports: [NgClass],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  public type = input<ButtonType>('primary');
  public customClasses = input<string>('');
  public buttonType = input<'button' | 'submit'>('button');
  public disabled = input<boolean>(false);
  public clickEvent = output<MouseEvent>();

  public onClick(event: MouseEvent): void {
    this.clickEvent.emit(event);
  }
}

export type ButtonType = 'primary' | 'secondary' | 'secondary-borderless' | 'error' | 'primary-v2' | 'secondary-v2' | 'error-v2';
